import palette from './palette'

const fontStack = '"Geist Sans", -apple-system, BlinkMacSystemFont, sans-serif'

const typography = {
  fontFamily: fontStack,
  htmlFontSize: 16,
  fontSize: 16,
  fontWeightLight: 300,
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightBold: 600,
  button: {
    fontSize: 14,
    fontWeight: 500,
  },
  h1: {
    fontFamily: fontStack,
    fontSize: '1.5rem',
    fontWeight: 600,
    letterSpacing: '-0.02em',
  },
  h2: {
    fontFamily: fontStack,
    fontSize: '1.25rem',
    fontWeight: 600,
    letterSpacing: '-0.02em',
  },
  h4: {
    fontFamily: fontStack,
    fontSize: '1rem',
    fontWeight: 500,
  },
  body1: {
    fontFamily: fontStack,
    fontSize: '1rem',
    fontWeight: 400,
    lineHeight: 1.5,
  },
  body2: {
    fontFamily: fontStack,
    fontSize: '0.875rem',
    fontWeight: 400,
    lineHeight: 1.5,
  },
  caption: {
    fontFamily: fontStack,
    fontSize: '0.825rem',
    fontWeight: 400,
    lineHeight: 1.25,
  },
  subtitle: {
    fontFamily: fontStack,
    fontSize: '0.75rem',
    color: palette.text.light,
  },
}

export default typography
